export type SnLayoutAppbarMode = 'standart' | 'fixed' | 'collapsed';
